<template>
  <div class="timelineControlsContainer">
    <div class="controls">
      <div class="controls__block left-handler-controls">
        <!-- Left moving panel -->
        <el-button-group class="controls-group">
          <el-button
            title="Left Crop -1sec"
            type="warning"
            size="mini"
            class="timeline-control-button"
            :disabled="leftCropControlsDisabled"
            @click="moveLeftCrop(-1)"
          >
            <span class="timeline-control-icon">
              <svg
                fill="currentColor"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="material-design-icon__svg"
              >
                <path
                  d="M11.5 3C16.15 3 20.08 6.03 21.47 10.22L19.1 11C18.05 7.81 15.04 5.5 11.5 5.5C9.54 5.5 7.77 6.22 6.38 7.38L9 10H2V3L4.6 5.6C6.45 4 8.85 3 11.5 3ZM14 12V17V22H12V18V14H10V12H12H14Z"
                >
                  <title>Left Crop -1sec</title>
                </path>
              </svg>
            </span>
          </el-button>
          <el-button
            title="Left Crop -5sec"
            type="warning"
            size="mini"
            class="timeline-control-button"
            :disabled="leftCropControlsDisabled"
            @click="moveLeftCrop(-5)"
          >
            <rewind5 class="timeline-control-icon" title="Left Crop -5sec" />
          </el-button>
          <el-button
            title="Left Crop -10sec"
            type="warning"
            size="mini"
            class="timeline-control-button"
            :disabled="leftCropControlsDisabled"
            @click="moveLeftCrop(-10)"
          >
            <rewind10 class="timeline-control-icon" title="Left Crop -10sec" />
          </el-button>

          <el-button
            title="Left Crop -30sec"
            type="warning"
            size="mini"
            class="timeline-control-button"
            :disabled="leftCropControlsDisabled"
            @click="moveLeftCrop(-30)"
          >
            <rewind30 class="timeline-control-icon" title="Left Crop -30sec" />
          </el-button>

          <el-button
            title="Move Left Crop To Cursor (Ctrl+I)"
            type="warning"
            size="mini"
            class="timeline-control-button"
            @click="moveLeftCropToCursor"
          >
            <update
              class="timeline-control-icon"
              title="Move Left Crop To Cursor (Ctrl+I)"
            />
          </el-button>

          <el-button
            title="Left Crop +30sec"
            type="warning"
            size="mini"
            class="timeline-control-button"
            :disabled="leftCropControlsDisabled"
            @click="moveLeftCrop(30)"
          >
            <fast-forward30
              class="timeline-control-icon"
              title="Left Crop +30sec"
            />
          </el-button>

          <el-button
            title="Left Crop +10sec"
            type="warning"
            size="mini"
            class="timeline-control-button"
            :disabled="leftCropControlsDisabled"
            @click="moveLeftCrop(10)"
          >
            <fast-forward10
              class="timeline-control-icon"
              title="Left Crop +10sec"
            />
          </el-button>

          <el-button
            title="Left Crop +5sec"
            type="warning"
            size="mini"
            class="timeline-control-button"
            :disabled="leftCropControlsDisabled"
            @click="moveLeftCrop(5)"
          >
            <fast-forward5
              class="timeline-control-icon"
              title="Left Crop +5sec"
            />
          </el-button>
          <el-button
            title="Left Crop +1sec"
            type="warning"
            size="mini"
            class="timeline-control-button"
            :disabled="leftCropControlsDisabled"
            @click="moveLeftCrop(1)"
          >
            <div>
              <span class="timeline-control-icon">
                <svg
                  fill="currentColor"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  class="material-design-icon__svg"
                >
                  <path
                    d="M13.5 12V22H11.5V14H9.5V12H13.5ZM11.5 3C14.15 3 16.55 4 18.4 5.6L21 3V10H14L16.62 7.38C15.23 6.22 13.46 5.5 11.5 5.5C7.96 5.5 4.95 7.81 3.9 11L1.53 10.22C2.92 6.03 6.85 3 11.5 3Z"
                  >
                    <title>Right Crop +1sec</title>
                  </path>
                </svg>
              </span>
            </div>
          </el-button>
        </el-button-group>
      </div>
      <!-- Center panel -->
      <div class="controls__block player-controls">
        <el-button-group class="controls-group">
          <el-button
            title="Move To Stream Start (I)"
            type="info"
            size="mini"
            class="timeline-control-button"
            @click="handleNDVRSkipBackwardButton"
          >
            <skip-backward
              class="timeline-control-icon"
              title="Move To Stream Start (I)"
            />
          </el-button>
          <el-button
            :type="rewind ? 'warning' : 'info'"
            :title="(rewind ? 'Normal ' : 'Rewind ') + '(Left Arrow)'"
            :disabled="rewindDisabled"
            size="mini"
            class="timeline-control-button"
            @click="handleNDVRRewindButton"
          >
            <rewind-outline
              class="timeline-control-icon"
              :title="(rewind ? 'Normal ' : 'Rewind ') + '(Left Arrow)'"
            />
          </el-button>

          <el-button
            :title="(isPlaying ? 'Pause ' : 'Play ') + '(Space, K)'"
            :disabled="playDisabled"
            type="info"
            size="mini"
            class="timeline-control-button"
            @click="handleNDVRPlayButton"
          >
            <div v-if="isPlaying == true">
              <pause-circle-outline
                class="timeline-control-icon"
                title="Pause (Space, K)"
              />
            </div>
            <div v-else>
              <play-circle-outline
                class="timeline-control-icon"
                title="Play (Space, K)"
              />
            </div>
          </el-button>
          <el-button
            :type="fastForward ? 'warning' : 'info'"
            :title="(fastForward ? 'Normal ' : 'Fast ') + '(Right Arrow)'"
            :disabled="fastForwardDisabled"
            size="mini"
            class="timeline-control-button"
            @click="handleNDVRFastForwardButton"
          >
            <fast-forward-outline
              class="timeline-control-icon"
              :title="(fastForward ? 'Normal ' : 'Fast ') + '(Right Arrow)'"
            />
          </el-button>

          <el-button
            :type="fastForward ? 'danger' : 'info'"
            :class="{ active: fastForward }"
            title="Move To Live (O)"
            size="mini"
            class="timeline-control-button live"
            @click="handleNDVRSkipForwardButton"
          >
            <img src="../../../assets/images/move_to_live.png" />
          </el-button>
        </el-button-group>
      </div>

      <!-- Right moving panel -->
      <div class="controls__block right-handler-controls">
        <el-button-group class="controls-group">
          <el-button
            title="Right Crop -1sec"
            type="danger"
            size="mini"
            class="timeline-control-button"
            :disabled="rightCropControlsDisabled"
            @click="moveRightCrop(-1)"
          >
            <div>
              <span class="timeline-control-icon">
                <svg
                  fill="currentColor"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  class="material-design-icon__svg"
                >
                  <path
                    d="M11.5 3C16.15 3 20.08 6.03 21.47 10.22L19.1 11C18.05 7.81 15.04 5.5 11.5 5.5C9.54 5.5 7.77 6.22 6.38 7.38L9 10H2V3L4.6 5.6C6.45 4 8.85 3 11.5 3ZM14 12V17V22H12V18V14H10V12H12H14Z"
                  >
                    <title>Left Crop -1sec</title>
                  </path>
                </svg>
              </span>
            </div>
          </el-button>
          <el-button
            title="Right Crop -5sec"
            type="danger"
            size="mini"
            class="timeline-control-button"
            :disabled="rightCropControlsDisabled"
            @click="moveRightCrop(-5)"
          >
            <rewind5 class="timeline-control-icon" title="Right Crop -5sec" />
          </el-button>
          <el-button
            title="Right Crop -10sec"
            type="danger"
            size="mini"
            class="timeline-control-button"
            :disabled="rightCropControlsDisabled"
            @click="moveRightCrop(-10)"
          >
            <rewind10 class="timeline-control-icon" title="Right Crop -10sec" />
          </el-button>
          <el-button
            title="Right Crop -30sec"
            type="danger"
            size="mini"
            class="timeline-control-button"
            :disabled="rightCropControlsDisabled"
            @click="moveRightCrop(-30)"
          >
            <rewind30 class="timeline-control-icon" title="Right Crop -30sec" />
          </el-button>
          <el-button
            title="Move Right Crop To Cursor (Ctrl+O)"
            type="danger"
            size="mini"
            class="timeline-control-button"
            @click="moveRightCropToCursor"
          >
            <update class="timeline-control-icon" />
          </el-button>
          <el-button
            title="Right Crop +30sec"
            type="danger"
            size="mini"
            class="timeline-control-button"
            :disabled="rightCropControlsDisabled"
            @click="moveRightCrop(30)"
          >
            <fast-forward30
              class="timeline-control-icon"
              title="Right Crop +30sec"
            />
          </el-button>
          <el-button
            title="Right Crop +10sec"
            type="danger"
            size="mini"
            class="timeline-control-button"
            :disabled="rightCropControlsDisabled"
            @click="moveRightCrop(10)"
          >
            <fast-forward10
              class="timeline-control-icon"
              title="Right Crop +10sec"
            />
          </el-button>
          <el-button
            title="Right Crop +5sec"
            type="danger"
            size="mini"
            class="timeline-control-button"
            :disabled="rightCropControlsDisabled"
            @click="moveRightCrop(5)"
          >
            <fast-forward5
              class="timeline-control-icon"
              title="Right Crop +5sec"
            />
          </el-button>
          <el-button
            title="Left Crop +1sec"
            type="danger"
            size="mini"
            class="timeline-control-button"
            :disabled="rightCropControlsDisabled"
            @click="moveRightCrop(1)"
          >
            <div>
              <span class="timeline-control-icon">
                <svg
                  fill="currentColor"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  class="material-design-icon__svg"
                >
                  <path
                    d="M13.5 12V22H11.5V14H9.5V12H13.5ZM11.5 3C14.15 3 16.55 4 18.4 5.6L21 3V10H14L16.62 7.38C15.23 6.22 13.46 5.5 11.5 5.5C7.96 5.5 4.95 7.81 3.9 11L1.53 10.22C2.92 6.03 6.85 3 11.5 3Z"
                  >
                    <title>Right Crop +1sec</title>
                  </path>
                </svg>
              </span>
            </div>
          </el-button>
        </el-button-group>
      </div>
      <div class="timeline-box-wrapper-right controls__block">
        <el-row type="flex" align="middle">
          <!--timer -->
          <el-col :span="7" :offset="1" class="time-block">
            <el-button
              title="Set Timezone"
              type="plain"
              size="mini"
              class="player-control-btn width-button btn-margin"
              @click="openTimezoneModal"
            >
              <clock-time-three-outline
                title="Set Timezone"
                class="player-control-icon"
              />
            </el-button>
            <span title="Playback time (Yellow cursor)" class="time-label">{{
              playerTime
            }}</span>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle">
          <el-checkbox v-model="checked" class="btnCheckbox btn-margin"
            >Thumbnail</el-checkbox
          >
        </el-row>
        <el-row type="flex" align="middle">
          <el-checkbox
            v-model="checkedLockRange"
            class="btnCheckbox btn-margin"
            >{{ labelRange }}</el-checkbox
          >
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
/** video controls icons */
import RewindOutline from "vue-material-design-icons/RewindOutline.vue";
import SkipBackward from "vue-material-design-icons/SkipBackward.vue";
import PlayCircleOutline from "vue-material-design-icons/PlayCircleOutline.vue";
import PauseCircleOutline from "vue-material-design-icons/PauseCircleOutline.vue";
import FastForwardOutline from "vue-material-design-icons/FastForwardOutline.vue";
/** crop borders icons  */
import Rewind5 from "vue-material-design-icons/Rewind5.vue";
import Rewind10 from "vue-material-design-icons/Rewind10.vue";
import Rewind30 from "vue-material-design-icons/Rewind30.vue";
import Update from "vue-material-design-icons/Update.vue";
import FastForward30 from "vue-material-design-icons/FastForward30.vue";
import FastForward10 from "vue-material-design-icons/FastForward10.vue";
import FastForward5 from "vue-material-design-icons/FastForward5.vue";
/** volume slider */
import "vue-slider-component/theme/default.css";
/** store imports */
import { mapState } from "vuex";
import { mapActions } from "vuex";

/** time formatting */
import { getTimeLineForWatch } from "@/utils/time.js";

import ClockTimeThreeOutline from "vue-material-design-icons/ClockTimeThreeOutline.vue";

/** shortcut utils */
import { subscribeToKeyup, subscribeToKeydown } from "@/utils/shortcuts.js";

// @group Media/Controls
// Timeline and playing controls panel
export default {
  name: "TimelineControls",
  components: {
    ClockTimeThreeOutline,
    /** video itself */
    RewindOutline,
    SkipBackward,
    PlayCircleOutline,
    PauseCircleOutline,
    FastForwardOutline,
    /** borders */
    Rewind5,
    Rewind10,
    Rewind30,
    Update,
    FastForward30,
    FastForward10,
    FastForward5
  },
  props: {
    // Player time UNIX timestamp
    time: {
      type: Number,
      required: true
    },
    // Timezone to display time
    timezone: {
      type: String,
      default: "UTC"
    },
    // is rewind mode enabled
    rewind: {
      type: Boolean,
      default: false
    },
    // is fast forward mode enabled
    fastForward: {
      type: Boolean,
      default: false
    },
    // is play button disabled
    playDisabled: {
      type: Boolean,
      default: false
    },
    // is rewind button disabled
    rewindDisabled: {
      type: Boolean,
      default: false
    },
    // is fast forward button disabled
    fastForwardDisabled: {
      type: Boolean,
      default: false
    },
    // are the left Crop Border Control Buttons Disabled
    leftCropControlsDisabled: {
      type: Boolean,
      default: false
    },
    // are the right Crop Border Control Buttons Disabled
    rightCropControlsDisabled: {
      type: Boolean,
      default: false
    },

  },
  data() {
    return {
      checked: true,
      checkedLockRange: false,
      labelRange: "Free range"
    };
  },
  watch: {
    checked() {
      this.$emit("changeValueCheckboxThumbnails", this.checked);
    },
    checkedLockRange() {
      if (this.checkedLockRange == false) {
        this.labelRange = "Free range";
        this.$emit("rangeInfoValue", this.checkedLockRange);
      } else {
        this.labelRange = "Fix range";
        this.$emit("rangeInfoValue", this.checkedLockRange);
      }
    }
  },
  computed: {
    ...mapState({
      isPlaying: state => state.ndvrPlayer.isPlaying,
      cropLeftBound: state => state.timeline.sliderLeftBound,
      cropRightBound: state => state.timeline.sliderRightBound
    }),
    // @vuese
    // Channel time string in format 'HH:MM:SS'
    playerTime() {
      const timestamp = this.time;
      if (!isNaN(timestamp) && timestamp !== 0) {
        return getTimeLineForWatch(timestamp, this.timezone);
      } else {
        return "--:--:--:--";
      }
    }
  },
  mounted() {
    /** shortcuts listeners */

    /** move to start */
    subscribeToKeyup("KeyI", this.handleNDVRSkipBackwardButton);

    /** move to live */
    subscribeToKeyup("KeyO", this.handleNDVRSkipForwardButton);

    /** play/pause keys */
    subscribeToKeyup("KeyK", this.togglePlayingState);
    subscribeToKeyup("Space", this.togglePlayingState, { prevent: true });

    /** rewind */
    subscribeToKeyup("ArrowLeft", this.handleNDVRRewindButton);

    /** fast forward */
    subscribeToKeyup("ArrowRight", this.handleNDVRFastForwardButton);

    /** crop handles moving */
    subscribeToKeydown("KeyI", this.moveLeftCropToCursor, {
      ctrl: true,
      prevent: true
    });
    subscribeToKeydown("KeyO", this.moveRightCropToCursor, {
      ctrl: true,
      prevent: true
    });
  },
  methods: {
    ...mapActions("timeline", ["moveSliderLeftBound", "moveSliderRightBound"]),
    // @vuese
    // `Play` button click handler
    handleNDVRPlayButton(event) {
      /** block play clicking by space/enter, because space-key is binded as shortcut for this functionality */
      if (event.pointerType == "") {
        return;
      }
      this.togglePlayingState();
      this.$emit("ndvrRewindStop");
    },
    // @vuese
    // Show select-timezone modal
    openTimezoneModal() {
      this.$emit("openTimezone");
    },
    // @vuese
    // Toggle play/pause state
    togglePlayingState() {
      if (this.rewind) {
        this.stopRewind();
      }

      if (this.fastForward) {
        this.stopFastForward();
      }

      if (this.isPlaying == true) {
        // User tried to stop stream
        this.$emit("ndvrPause");
      } else {
        // User tried to start stream
        this.$emit("ndvrPlay");
      }
    },
    // @vuese
    // Forward skip button handler
    handleNDVRSkipForwardButton() {
      // User tried to go stream forward
      // this.togglePlayingState();
      if (this.isPlaying == false) {
        this.$emit("ndvrPlay");
      }
      this.$emit("ndvrSkipToLive");
    },
    // @vuese
    // Backward button handler
    handleNDVRSkipBackwardButton() {
      // User tried to go stream back
      this.$emit("ndvrSkipToStart");
    },
    // @vuese
    // Move left crop border
    // @arg value - time step in seconds
    moveLeftCrop(value) {
      this.$emit("moveLeftCrop", value);
    },
    // @vuese
    // Move right crop border
    // @arg value - time step in seconds
    moveRightCrop(value) {
      this.$emit("moveRightCrop", value);
    },
    // @vuese
    // Moves left crop border to current cursor position
    moveLeftCropToCursor() {
      this.$emit("moveLeftCropToCursor");
    },
    // @vuese
    // Moves right crop border to current cursor position
    moveRightCropToCursor() {
      this.$emit("moveRightCropToCursor");
    },
    // @vuese
    // Deprecated
    handleNDVRFFButton() {
      // Unused
      this.$emit("ndvrFF");
    },
    // @vuese
    // Enable/disable rewind playing mode
    handleNDVRFastForwardButton() {
      if (this.rewind) {
        this.stopRewind();
      }

      if (this.fastForward) {
        this.stopFastForward();
      } else {
        this.startFastForward();
      }
    },
    // @vuese
    // Enable/disable fast playing mode
    handleNDVRRewindButton() {
      if (this.fastForward == true) {
        this.stopFastForward();
      }

      if (this.rewind) {
        this.stopRewind();
      } else {
        this.startRewind();
      }
    },
    // @vuese
    // Set video fast mode
    startFastForward() {
      // User tried to speed up video
      this.$emit("ndvrFFStart");
    },
    // @vuese
    // Set video slow mode
    stopFastForward() {
      // User tried to slow video
      this.$emit("ndvrFFStop");
    },
    // @vuese
    // Set video backward mode
    startRewind() {
      // User tried to run video backwards
      this.$emit("ndvrRewindStart");
    },
    // @vuese
    // Set video forward mode
    stopRewind() {
      // User tried to run video in normal direction
      this.$emit("ndvrRewindStop");
    }
  }
};
</script>

<style lang="scss">
.el-checkbox__inner {
  border: 1px solid #ffffff;
}
.timeline-box-wrapper-right {
  display: flex;
}

.btnCheckbox {
  margin: 0 5px;
}

.btn-margin {
  padding: 0 3px;
}

@mixin timeline-icon-size($icon-size) {
  .timeline-control-icon {
    .material-design-icon__svg {
      height: $icon-size !important;
      width: $icon-size !important;
    }
  }
}

.timelineControlsContainer {
  margin: 5px;
  padding: 5px;
}
.controls {
  display: flex;
  justify-content: space-between;
}

.width-button {
  background: #7a7a7a;
}

.time-block {
  display: flex;
  align-items: center;
}

.time-label {
  font-weight: bold;
  font-size: 1.2rem;
  margin-left: 5px;
}
/*
$--sm: 768px !default;
$--md: 992px !default;
$--lg: 1200px !default;
$--xl: 1920px !default;

$--breakpoints: (
  'xs' : (max-width: $--sm - 1),
  'sm' : (min-width: $--sm),
  'md' : (min-width: $--md),
  'lg' : (min-width: $--lg),
  'xl' : (min-width: $--xl)
);
*/
.timeline-control-button {
  width: 2.5rem;
  height: 2.5rem;
}
.el-button.timeline-control-button.live.active {
  background-color: #c11919;
  border-color: #c11919;
}
.el-button.timeline-control-button.live.active:hover {
  background-color: #b12121;
  border-color: #b12121;
}
.el-button.timeline-control-button.live.active:active {
  background-color: #df3333;
  border-color: #df3333;
}
.el-button.timeline-control-button.live:not(.active) {
  background-color: #1d62d9;
}
.el-button.timeline-control-button.live:not(.active):hover {
  background-color: #2b60c1;
}
.el-button.timeline-control-button.live:not(.active):active {
  background-color: #3571de;
}
.timeline-control-button img {
width: 100%
}

@include timeline-icon-size(1.5rem);

/** Mobile */
@media only screen and (max-width: 767px) {
  .timeline-box-wrapper-right {
    display: flex;
  }
  .timeline-control-button {
    height: 2rem;
    flex-grow: 1;
  }
  .player-controls .timeline-control-button {
    height: 3rem;
  }

  @include timeline-icon-size(1.5rem);

  .controls {
    flex-direction: column;
    width: 100%;
  }
  .controls__block {
    justify-content: center;
  }
  .controls__block:not(:last-child) {
    margin-bottom: 5px;
  }
  .controls__block.player-controls {
    order: 0;
    margin-bottom: 15px;
  }
  .controls__block.left-handler-controls {
    order: 1;
  }
  .controls__block.right-handler-controls {
    order: 2;
  }
  .controls-group {
    display: flex;
    justify-content: stretch;
  }
  .el-button--mini {
    padding: 3px 3px;
    font-size: 10px;
    border-radius: 3px;
  }
}
@media only screen and (min-width: 768px) {
  .timeline-box-wrapper-right {
    display: flex;
    flex-direction: column;
  }
  .player-control-btn {
    width: 2.2rem;
    height: 2.2rem;
  }
  .player-control-icon .material-design-icon__svg {
    width: 1.6rem !important;
    height: 1.6rem !important;
  }
  .timeline-control-button {
    width: 2.3rem;
    height: 2.3rem;
  }

  @include timeline-icon-size(1.2rem);

  .el-button--mini {
    padding: 3px 3px;
    font-size: 10px;
    border-radius: 3px;
  }
}

/** Desktop */
@media only screen and (min-width: 992px) {
  .timeline-box-wrapper-right {
    display: flex;
    flex-direction: column;
  }
  .player-control-btn {
    width: 1.8rem;
    height: 1.8rem;
  }
  .player-control-icon .material-design-icon__svg {
    width: 1.2rem !important;
    height: 1.2rem !important;
  }

  .timeline-control-button {
    width: 1.7rem;
    height: 1.7rem;
  }

  @include timeline-icon-size(1.1rem);

  .el-button--mini {
    padding: 4px 4px;
    font-size: 10px;
    border-radius: 3px;
  }
}
@media only screen and (min-width: 1200px) {
  .timeline-box-wrapper-right {
    display: flex;
    flex-direction: column;
  }
  .player-control-btn {
    width: 2.4rem;
    height: 2.4rem;
  }
  .player-control-icon .material-design-icon__svg {
    width: 1.5rem !important;
    height: 1.5rem !important;
    margin: 0 2px;
  }

  .timeline-control-button {
    width: 2rem;
    height: 2rem;
  }
  @include timeline-icon-size(1.3rem);
}

@media only screen and (min-width: 1300px) {
  .timeline-box-wrapper-right {
    display: flex;
    flex-direction: row;
  }
}

@media only screen and (min-width: 1920px) {
  .player-control-btn {
    width: 2.5rem;
    height: 2.5rem;
  }
  .time-label {
    font-size: 1.4rem;
  }

  .player-control-icon .material-design-icon__svg {
    width: 1.5rem !important;
    height: 1.5rem !important;
  }

  .timeline-control-button {
    width: 2.5rem;
    height: 2.5rem;
  }
  @include timeline-icon-size(1.5rem);
}

.timelineColumn {
  min-height: 3rem;
}
</style>
